document.addEventListener("DOMContentLoaded", async function () {
  
  const backButton = document.querySelector(".backButton");
 const nextButtons = [document.getElementById("nextButton1")];
  const tiers = document.querySelectorAll(".tierBox div");
   const sampleLimitElement = document.querySelector(".sample-limit");
  const sampleProductsContainer = document.querySelector(".sampleProducts");
  const tierMessageElement = document.querySelector(".tier-message");
  const tierHead = document.querySelector(".tier");
  const Head = document.querySelector(".head");
  const mess = document.querySelector(".mess");
  const choose = document.querySelector(".choose");
  const noTier = document.querySelector(".noTier");

    const nextButton = document.getElementById('proceed');
 

    const sampleProductsData = JSON.parse(document.getElementById('sample-products-data').textContent);

   // Track selected product IDs
  const selectedProductIds = new Set();
  
   function cleanTitle(title) {
    // Remove "Tier- 1", "Tier- 2", and "Tier- 3" from the title
    return title.replace(/Tier- 1|Tier- 2|Tier- 3/g, "").trim();
  }

  
console.log(sampleProductsData,"sampleProductsData")
   function getFilteredProducts(tierNumber) {
    // Filter products based on the active tier
    return sampleProductsData.products.filter(product => {
      const tier1Condition = tierNumber >= 1 && product.title.includes("Tier- 1");
      const tier2Condition = tierNumber >= 2 && product.title.includes("Tier- 2");
      // const tier3Condition = tierNumber >= 3 && product.title.includes("Tier- 3");

      return tier1Condition || tier2Condition ;
    });
  }

function updateSamples(tierNumber) {
    let sampleLimit;

    // Determine the sample limit based on the active tier
    switch (tierNumber) {
        case 1:
            sampleLimit = 2;
            break;
        case 2:
            sampleLimit = 4;
            break;
        default:
            sampleLimit = 0;
    }

    sampleLimitElement.textContent = sampleLimit;

    // Clear the previous sample products
    sampleProductsContainer.innerHTML = '';

    // Get filtered products based on the active tier
    const filteredProducts = getFilteredProducts(tierNumber);

    // Filter products based on Tier-1 or Tier-2 in the title
    const tierProducts = filteredProducts.filter(product => {
       console.log(`Checking product: ${product.title}`);
      const title = product.title.replace(/\s+/g, "").toLowerCase();
        return (tierNumber === 1 && title.includes("tier-1")) ||
               (tierNumber === 2 && title.includes("tier-2"));
    });

    // Check if any products match the tier filter
    if (tierProducts.length === 0) {
        const noProductsMessage = document.createElement("p");
        noProductsMessage.className = "text-center text-gray-600";
        noProductsMessage.textContent = "No sample products available for this tier.";
        sampleProductsContainer.appendChild(noProductsMessage);
        return;
    }

    // Add the filtered sample products
    tierProducts.forEach((product, index) => {
        const sampleProduct = document.createElement("div");
        sampleProduct.className = "sampleProduct p-4 border border-gray-200 rounded-lg shadow-lg bg-white cursor-pointer transition-transform duration-300 hover:scale-105";
        sampleProduct.dataset.index = index;
        sampleProduct.dataset.productId = product.id; // Add product ID to the dataset

        const title = document.createElement("h3");
        title.className = "text-lg font-semibold mb-2";
        title.textContent = cleanTitle(product.title); // Clean the title

        const description = document.createElement("p");
        description.className = "text-gray-600";
        description.textContent = product.description;

        const image = document.createElement("img");
        image.src = product.image;
        image.alt = product.title;
        image.className = "w-full h-64 object-cover";

        const price = document.createElement("p");
        price.className = "text-gray-800 font-bold";
        price.textContent = product.price;

        sampleProduct.appendChild(image);
        sampleProduct.appendChild(title);
        sampleProduct.appendChild(description);
        sampleProduct.appendChild(price);
        sampleProductsContainer.appendChild(sampleProduct);

        // Update selection state
        if (selectedProductIds.has(product.id)) {
            sampleProduct.classList.add("selected");
        }

        sampleProduct.addEventListener("click", function () {
            const productId = this.dataset.productId;
            const selectedCount = document.querySelectorAll(".sampleProduct.selected").length;

            if (this.classList.contains("selected")) {
                this.classList.remove("selected");
                selectedProductIds.delete(productId);
                removeProductFromCart(productId);
            } else if (selectedCount < sampleLimit) {
                this.classList.add("selected");
                selectedProductIds.add(productId);
                addProductToCart(product);
            } else {
                alert(`You can only select up to ${sampleLimit} samples.`);
            }
        });
    });
}



   function storeProductId(productId) {
    let storedProductIds = JSON.parse(localStorage.getItem('sampleProductIds')) || [];
    if (!storedProductIds.includes(productId)) {
      storedProductIds.push(productId);
      localStorage.setItem('sampleProductIds', JSON.stringify(storedProductIds));
    }
  }


   function storeProductId(productId) {
    let storedProductIds = JSON.parse(localStorage.getItem('sampleProductIds')) || [];
    if (!storedProductIds.includes(productId)) {
      storedProductIds.push(productId);
      localStorage.setItem('sampleProductIds', JSON.stringify(storedProductIds));
    }
  }

  function addProductToCart(product) {
    const variantId = product.variants[0].id; // Assuming the first variant is used
    const quantity = 1;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Product added to cart:', data);
      storeProductId(product.id);
      updateCartTotals(); // Update cart totals after adding
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
       updateCartTotals();
    });
  }


  // const timelessSlider = document.getElementById("timelessSlider");
  // const animation = document.getElementById("animation");
  // const footer = document.getElementById("footer");
  const defaultNavbar = document.getElementById("defaultNavbar");
  const cartNavbar = document.getElementById("cartNavbar");

  const showHeaderSidebar = document.getElementById("showHeaderSidebar");
  showHeaderSidebar.addEventListener("click", () => {
    document.querySelector(".cartSectionLg > div:nth-child(1)").classList.remove("active");
  });

  const closeHeaderSidebar = document.getElementById("closeHeaderSidebar");
  closeHeaderSidebar.addEventListener("click", () => {
    document.querySelector(".cartSectionLg > div:nth-child(1)").classList.add("active");
  });

  const stepperContainer = document.querySelector(".cartSectionLg > div:nth-child(1)");
  const steps = document.querySelectorAll(".step");
  const stepContents = document.querySelectorAll(".cartSectionLg > .cartStep");

  let currentStep = 1;

  function showStep(stepNumber) {
    stepContents.forEach((stepContent) => {
      stepContent.style.display = "none";
    });
    steps.forEach((step, index) => {
      if (index === stepNumber - 1) {
        step.classList.add("active");
      } else {
        step.classList.remove("active");
      }
    });
    stepContents[stepNumber - 1].style.display = "block";

    if (stepNumber === 1) {
      backButton.style.display = "none";
      nextButton.style.display = 'none';
  
      defaultNavbar.style.display = "block";
      cartNavbar.style.display = "none";
      stepperContainer.style.top = "113.5px";
      history.pushState({ step: currentStep }, "", `?step=1`);
      
    } else {
      backButton.style.display = "inline-block";
   nextButton.style.display = 'block';
      defaultNavbar.style.display = "none";
      cartNavbar.style.display = "block";
      stepperContainer.style.top = "81px";
    }

    if (stepNumber > 1) {
      steps[stepNumber - 2].classList.add("completed");
      steps[stepNumber - 2].querySelector(".bulletDot").classList.add("completed");
    }
  }

  function goToNextStep() {
    
    
    currentStep++;
    document.querySelectorAll(".bulletDot").forEach((bulletDot) => {
      bulletDot.classList.remove("active");
    });
    steps[currentStep - 1].querySelector(".bulletDot").classList.add("active");
    showStep(currentStep);
    window.scrollTo({ top: 0 });
     history.pushState({ step: currentStep }, "", `?step=${currentStep}`);
  }

async  function goToPreviousStep() {
    if (currentStep > 1) {
      for (let i = currentStep - 1; i < steps.length; i++) {
        steps[i].classList.remove("completed");
      }
      document.querySelectorAll(".bulletDot").forEach((bulletDot) => {
        bulletDot.classList.remove("active");
      });
      currentStep--;
      steps[currentStep - 1].querySelector(".bulletDot").classList.add("active");

      updateBulletDotClasses();
      showStep(currentStep);
       history.pushState({ step: currentStep }, "", `?step=${currentStep}`);
      await updateCartTotals()
    }
  }



  
function renderCart(cart) {
  const cartContainer = document.querySelector('.cart-container');
  
  if (cart.items.length === 0) {
    cartContainer.innerHTML = '<h2 class="text-center">Your Cart is Empty</h2>';
  } else {
      const filteredItems = cart.items.filter(item => 
      item.variant_id !== 44608473268420 && item.variant_id !== 44608473891012
    );

    const cartHTML = filteredItems.map(item => `
      <div class="CartPageProduct rounded-xl bg-white border-2 border-gray-400">
        <div class="flex items-center px-4 py-2 gap-4 w-full text-sm">
          <div class="border border-gray-300">
            <img class="border border-gray-300" width="100" height="200" src="${item.image}" alt="${item.title}" />
          </div>
          <div class="flex flex-col py-2 gap-2 w-full">
            <h1 class="mb-4">${item.title}</h1>
            <div class="flex items-center justify-between text-xs">
              <p>Price</p>
              <span>${(item.price / 100).toFixed(2)}</span>
            </div>
            <div class="flex items-center justify-between text-xs">
              <p>Weight</p>
              <span>${item.variant_title ? item.variant_title : '0 ml'}</span>
            </div>
            <div class="flex items-center justify-between my-2 text-xs">
              <p>Quantity</p>
              <div class="border border-gray-700 rounded-3xl">
                <div class="flex items-center justify-center gap-2 px-4">
                  <button class="text-center text-xs decrement-btn" data-item-id="${item.id}">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-3 h-3">
                      <path fill-rule="evenodd" d="M4 10a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 10Z" clip-rule="evenodd" />
                    </svg>
                  </button>
                  <p id="quantity-${item.id}" class="text-center text-md font-semibold">${item.quantity}</p>
                  <button class="text-center text-xs increment-btn" data-item-id="${item.id}">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-3 h-3">
                      <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr/>
        <div class="w-full px-4 py-4">
          <div class="flex items-center justify-between text-xs">
            <div class="flex items-center justify-center gap-2">
              <p>Subtotal</p>
              <span id="subtotal-${item.id}">${(item.final_line_price / 100).toFixed(2)}</span>
            </div>
            <div>
              <a href="javascript:void(0);" class="remove-item-btn" data-item-id="${item.id}" data-variant-id="${item.variant_id}">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    `).join('');
    
    cartContainer.innerHTML = cartHTML;
      // Attach event listeners after HTML is rendered
    bindQuantityButtons();
    bindRemoveButtons();
  }
}

function bindQuantityButtons() {
  document.querySelectorAll(".increment-btn").forEach((btn) => {
    btn.addEventListener("click", function () {
      const itemId = this.dataset.itemId;
      const quantityElement = document.getElementById(`quantity-${itemId}`);
      let currentQuantity = parseInt(quantityElement.textContent);

      if (!isNaN(currentQuantity)) {
        quantityElement.textContent = currentQuantity + 1;
        updateShopifyCart(itemId, currentQuantity + 1);
         updateGrandTotal()
         console.log("Quantity incremented:");
      }
    });
  });

  document.querySelectorAll(".decrement-btn").forEach((btn) => {
    btn.addEventListener("click", function () {
      const itemId = this.dataset.itemId;
      const quantityElement = document.getElementById(`quantity-${itemId}`);
      let currentQuantity = parseInt(quantityElement.textContent);

      if (currentQuantity === 1) {
        // Remove product from cart when quantity is 1 and decrement is clicked
        updateShopifyCart(itemId, 0);
        // Remove the product element from DOM
        const productElement = this.closest('.CartPageProduct');
        if (productElement) {
          productElement.remove();
        }
        updateGrandTotal();
        console.log("Product removed from cart:");
      }else if (currentQuantity > 1 && !isNaN(currentQuantity)) {
        quantityElement.textContent = currentQuantity - 1;
        updateShopifyCart(itemId, currentQuantity - 1);
         updateGrandTotal()
        console.log("Quantity decremented:");
      }
    });
  });
}
  

  function bindRemoveButtons() {
  document.querySelectorAll(".remove-item-btn").forEach((btn) => {
    btn.addEventListener("click", function () {
      const itemId = this.dataset.itemId;
      updateShopifyCart(itemId, 0);
      localStorage.setItem("deleted","true")
     updateCart()
      updateGrandTotal()
    });
  });
}
   const smallGiftBoxVariantId = 44608473268420; // Small Gift Box variant ID
  const largeGiftBoxVariantId = 44608473891012; // Large Gift Box variant ID

  const giftBoxSelect = document.getElementById('gift-box');
  const giftBoxSummary = document.getElementById('gift-box-summary');
  const giftBoxCost = document.getElementById('gift-box-cost');
  const grandTotal = document.getElementById('grand-total');
  const bagTotal = document.getElementById('bag-total');

  // Function to update the cart when a gift box is selected
  const updateCartWithGiftBox = async (variantId, price) => {
    // Add the selected gift box variant to the cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Gift box added to cart:', data);
      // Update the gift box summary and cost
      giftBoxSummary.classList.remove('hidden');
      giftBoxCost.textContent = `Rs: ${price}/-`;
  localStorage.setItem('selectedGiftBox', JSON.stringify({ variantId, price }));
      // Update the grand total (if needed, replace with actual total fetching logic)
      updateGrandTotal();
    })
    .catch(error => console.error('Error adding gift box to cart:', error));
  };

  // Function to remove the gift box from the cart
// Function to remove the gift box from the cart
async function removeGiftBoxFromCart(variantId) {
  // Fetch the current cart details
  fetch("/cart.js")
    .then((response) => response.json())  // Parse the cart response as JSON
    .then((cart) => {
      // Find the gift box item in the cart based on its title (you may need to adjust the title check based on your actual gift box title)
      const giftBoxLineItem = cart.items.find((item) =>
        item.title.includes("Gift Box") // Change this condition if your gift box title is different
      );

      // If a gift box is found, remove it from the cart
      if (giftBoxLineItem) {
        // Make a POST request to change the cart and remove the gift box by setting its quantity to 0
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: giftBoxLineItem.key,  // Use the line item key to target the correct item
            quantity: 0,  // Set quantity to 0 to remove the item
          }),
        })
          .then((response) => response.json())  // Parse the response from the server
          .then((data) => {
            console.log("Gift box removed from cart:", data);  // Log success
             giftBoxSummary.classList.add('hidden');
        localStorage.removeItem('selectedGiftBox');
        updateGrandTotal();
            return data;
          })
          .catch((error) => {
            console.error("Error removing gift box from cart:", error);  // Log any errors
          });
      }
    })
    .catch((error) => {
      console.error("Error fetching cart:", error);  // Log errors in fetching the cart
    });
}



  // Function to update the grand total by fetching the cart's total price
  const updateGrandTotal = () => {

    fetch('/cart.js', {
      method: 'GET',
    })
    .then(response => response.json())
    .then(cart => {
      grandTotal.textContent = `Rs: ${cart.total_price / 100}`;
      let bagTotalPrice = cart.items_subtotal_price / 100;
       const giftBoxItem = cart.items.find(item => 
      item.variant_id === smallGiftBoxVariantId || item.variant_id === largeGiftBoxVariantId
    );

    if (giftBoxItem) {
      bagTotalPrice -= giftBoxItem.line_price / 100;
    }

    // Update the Bag Total
    bagTotal.textContent = `₹${bagTotalPrice}`;
    })
    .catch(error => console.error('Error fetching cart total:', error));
  };

   const loadSelectedGiftBox = () => {
    const storedGiftBox = localStorage.getItem('selectedGiftBox');
    if (storedGiftBox) {
      const { variantId, price } = JSON.parse(storedGiftBox);
      // Show the gift box summary and update the cost
      giftBoxSummary.classList.remove('hidden');
      giftBoxCost.textContent = `Rs: ${price}/-`;
      // Update the grand total
      updateGrandTotal();

      // Ensure the dropdown reflects the correct selection
      if (variantId === smallGiftBoxVariantId) {
        giftBoxSelect.value = 'small';
      } else if (variantId === largeGiftBoxVariantId) {
        giftBoxSelect.value = 'large';
      }
    } else {
      // If no gift box is selected, hide the summary
      giftBoxSummary.classList.add('hidden');
      giftBoxSelect.value = 'none';
    }
  };

  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  // Handle changes in the gift box selection
giftBoxSelect.addEventListener('change', async() => {
const selectedOption = giftBoxSelect.value;
  
 if (selectedOption === 'none') {
    const storedGiftBox = localStorage.getItem('selectedGiftBox');
    if (storedGiftBox) {
      const { variantId } = JSON.parse(storedGiftBox);
      await removeGiftBoxFromCart(variantId); // Remove the previous gift box
    }
    return;
  }

   // If a new gift box is selected, remove the previous one from the cart first
  const storedGiftBox = localStorage.getItem('selectedGiftBox');
  if (storedGiftBox) {
    const { variantId: previousVariantId } = JSON.parse(storedGiftBox);
    // Remove the previous gift box from the cart
    await removeGiftBoxFromCart(previousVariantId);
    await delay(1000);
  }
  

  // Determine the gift box variant and price based on selection
  let variantId, price;
  if (selectedOption === 'small') {
    variantId = smallGiftBoxVariantId;
    price = 95;
  } else if (selectedOption === 'large') {
    variantId = largeGiftBoxVariantId;
    price = 150;
  }

  // Add the selected gift box to the cart
  await updateCartWithGiftBox(variantId, price);

});

    window.addEventListener('load', loadSelectedGiftBox);


   function updateTierMessage(tierNumber) {
    let message;

    switch (tierNumber) {
      case 1:
        message = "You have unlocked TIER-1 free sample slab. Please choose any 2 samples of your choice, absolutely free. You can only select up to 2 samples.";
        break;
      case 2:
        message = "You have unlocked TIER-2 free sample slab. Please choose any 4 samples of your choice, absolutely free. You can only select up to 4 samples.";
        break;
      case 3:
        message = "You have unlocked TIER-3 free sample slab. Please choose any 6 samples of your choice, absolutely free. You can only select up to 6 samples.";
        break;
      default:
        message = "You haven't unlocked any tier. Please shop more to unlock a tier and get free samples.";
    }

    if (tierMessageElement) {
      tierMessageElement.textContent = message;
    }
  }

  const shareButton = document.getElementById("shareButton");
const shareOptions = document.getElementById("shareOptions");
const shareDiv = document.querySelector(".bg-white.p-4.rounded-lg.text-sm");

// Function to check if the cart is empty and hide/show the share button
async function checkCartAndUpdateShareButton() {
  const cart = await fetch('/cart.js').then(response => response.json());

  // If the cart has no items, hide the Share button
  if (cart.items.length === 0) {
    shareDiv.classList.add("hidden"); // Hide the share section
  } else {
    shareDiv.classList.remove("hidden"); // Show the share section
  }
}

// Run the function to check the cart state on page load
checkCartAndUpdateShareButton();

// Toggle the visibility of share options when the "Share All Items" button is clicked
shareButton.addEventListener("click", async function () {
  // Get the cart items and generate the product URLs
  const cart = await fetch('/cart.js').then(response => response.json());
  let productUrls = [];

  // Loop through each item in the cart and generate the product URLs
  cart.items.forEach(item => {
    const productUrl = `https://timelessbeautysecrets.com/products/${item.handle}`;
    productUrls.push(productUrl);
  });

  // Create a professional message with all product URLs
  const message = `
Hello, 

I wanted to share with you some amazing products from Timeless Beauty Secrets:

${productUrls.join("\n")}

Visit our website to explore more and shop now: https://timelessbeautysecrets.com

Best regards,
Your friend at Timeless Beauty Secrets
  `.trim();

  // Get the share options links and update them with the message
  const emailLink = document.querySelector('a[href^="mailto"]');
  const whatsappLink = document.querySelector('a[href^="https://api.whatsapp.com"]');
  const facebookLink = document.querySelector('a[href^="https://www.facebook.com"]');
  const copyLinkButton = document.getElementById("copyLink");

  // Update the share links with the message
  emailLink.href = `mailto:?subject=Check%20out%20these%20amazing%20products&body=${encodeURIComponent(message)}`;
  whatsappLink.href = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
  facebookLink.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(message)}`;

  // Set up the copy link functionality
  copyLinkButton.addEventListener("click", function () {
    navigator.clipboard.writeText(message).then(() => {
      alert("Links copied to clipboard!");
    });
  });

  // Show the share options
  shareOptions.classList.toggle("show");
});



  async function updateCart() {
    try {
       const cart = await fetch('/cart.js').then(response => response.json());
       // Array to store the product URLs
    let productUrls = [];
    
    // Loop through each item in the cart
    cart.items.forEach(item => {
        // Construct the URL using the product's handle
        const productUrl = `https://timelessbeautysecrets.com/products/${item.handle}`;
        
        // Push the URL to the productUrls array
        productUrls.push(productUrl);
    });

    // Log all the product URLs to the console
    // console.log(productUrls);
    
  renderCart(cart);
  updateCartTotals(cart);
    } catch (error) {
      console.error("Error updating cart:", error);
    }
 
}

  
updateCart()
  

  
  async function updateCartTotals(cart) {
     if (!cart || !cart.items) {
    console.error("Invalid cart object:", cart);
    return;
  }
     if (cart.items.length === 0) {
        document.querySelector("#bag-total").textContent = "₹0.00";
        document.querySelector("#promo-applied").textContent = "- ₹0.00";
        document.querySelector("#grand-total").textContent = "₹0.00";

        // Hide tier messages when the cart is empty
        document.querySelectorAll('.tier-message-text').forEach(message => {
            message.style.display = "none";
        });

        document.querySelector("#no-tier").style.display = "block";
        return;
    }
    console.log(cart,"cart")
    let bagTotal = 0;

    cart.items.forEach(item => {
    const itemQuantity = item.quantity;
    const itemPrice = item.price;
    const subtotal = itemQuantity * itemPrice;

    document.querySelector(`#subtotal-${item.id}`).textContent = `₹${(subtotal / 100).toFixed(2)}`;
    bagTotal += subtotal;
  });

    const promoAppliedElement = document.querySelector("#promo-applied");
    const bagTotalElement = document.querySelector("#bag-total");
    const grandTotalElement = document.querySelector("#grand-total");

    if (promoAppliedElement && bagTotalElement && grandTotalElement) {
         const promoDiscount = Math.abs(parseFloat(promoAppliedElement.textContent.replace(/[^\d.-]/g, "")) || 0);
       const grandTotal = ((bagTotal / 100) - promoDiscount).toFixed(2);

      bagTotalElement.textContent = `₹${(bagTotal / 100).toFixed(2)}`;
      grandTotalElement.textContent = `₹${grandTotal}`;
    } else {
      console.error("One or more elements for totals are missing.");
    }
   


// Remove the 'bg-[#009290]' class and 'active' class from all tiers
tiers.forEach(tier => {
  tier.classList.remove("bg-[#009290]");
  tier.classList.remove("active");
});

const bagTotalInRupees = Math.floor(bagTotal / 100); // Convert the bagTotal from cents to rupees and round down



let activeTier = 0;

// Hide all tier-related messages by default
Head.style.display = "none";
mess.style.display = "none";
choose.style.display = "none";   
noTier.style.display = "none";
    
const tierMessages = document.querySelectorAll('.tier-message-text');
    const tierTitles = document.querySelectorAll('.tier-title');

// Check the bag total and determine the active tier
let newActiveTier = 0;
if (bagTotalInRupees >= 2500 && bagTotalInRupees < 5000) {
  newActiveTier = 1; // Tier-1: Rs. 2500/- (Eligible for any 2 samples from slab 1)
} else if (bagTotalInRupees >= 5000) {
  newActiveTier = 2; // Tier-2: Rs. 5000/- (Eligible for any 4 samples from slab 2)
}

if (newActiveTier > 0) {
  // A tier is active
  noTier.style.display = "none";
  Head.style.display = "block";
  mess.style.display = "block";
  choose.style.display = "block";
  tierHead.textContent = `Tier- ${newActiveTier}`;
  activeTier = newActiveTier;

  // Remove active classes from all tiers first
  tiers.forEach(tier => {
    tier.classList.remove("bg-[#009290]", "active");
  });

  // Add active classes to the current tier
  tiers[activeTier - 1].classList.add("bg-[#009290]", "active");
    // Hide inactive tiers
  tiers.forEach((tier, index) => {
    if (index + 1 === activeTier) {
      tier.style.display = "block"; // Show active tier
    } else {
      tier.style.display = "none"; // Hide inactive tiers
    }
  });
   tierMessages.forEach(message => {
    message.style.display = "none";
  });

  // Show message about next tier
  const nextTierAmount = newActiveTier === 1 ? 5000 : null;
  const remainingAmount = nextTierAmount ? nextTierAmount - bagTotalInRupees : 0;
  
  if (remainingAmount > 0) {
    mess.textContent = `Shop for ₹${remainingAmount} more to unlock Tier-2 and get more free samples!`;
    choose.textContent = `Or choose any two free sample of your choice.`;
  } else {
    mess.textContent = `You have unlocked Tier-${newActiveTier} free sample slab. Please choose any four free samples.`;
    choose.style.display = "none"
  }
} else {
  // No tier is active
  Head.style.display = "none";
  mess.style.display = "block";
  noTier.style.display = "block";
  activeTier = 0;

  // Show message about how much more to spend for Tier 1
  const remainingAmount = 2500 - bagTotalInRupees;
  if (remainingAmount > 0) {
    mess.textContent = `Shop for ₹${remainingAmount} more to unlock Tier-1 and get free samples!`;
  } else {
    mess.textContent = "You haven't unlocked any tier. Please shop more to unlock a tier and get free samples.";
  }

  // Ensure no tier classes are active
  tiers.forEach(tier => {
    tier.classList.remove("bg-[#009290]", "active");
  });

  // Show all tier messages
  tierMessages.forEach(message => {
    message.style.display = "block";
  });

  // Remove sample products from cart and clear selections
  removeSampleProductsFromCart();
}
    // Adjust the margin-top of h1 elements based on the visibility of tier messages
tierMessages.forEach((message, index) => {
  const title = tierTitles[index]; // Assuming titles and messages have a 1-to-1 relationship
  if (message.style.display === "none") {
    title.style.marginTop = "8px";
  } else {
    title.style.marginTop = "0"; // Reset margin if the message is visible
  }
});

    // Update the samples for the active tier
    updateSamples(activeTier);

    
  }


  
function updateBulletDotClasses() {
    steps.forEach((step, index) => {
      if (index < currentStep - 1) {
        step.querySelector(".bulletDot").classList.add("completed");
        step.querySelector(".bulletDot").classList.remove("active");
      } else if (index === currentStep - 1) {
        step.querySelector(".bulletDot").classList.add("active");
        step.querySelector(".bulletDot").classList.remove("completed");
      } else {
        step.querySelector(".bulletDot").classList.remove("completed");
        step.querySelector(".bulletDot").classList.remove("active");
      }
    });
  }
  
function updateShopifyCart(variantId, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity,
    }),
  })
  .then(response => response.json())
  .then(data => {
    console.log('Cart updated:', data);
    localStorage.setItem("quantity","true")
    updateCart() // Recalculate totals after updating the cart
    updateGrandTotal();
  })
  .catch(error => {
    console.error('Error updating cart:', error);
  });
}
 
// Function to fetch cart with optional delay
async function fetchCartWithDelay(delay = 500) {
  // Introduce a delay to allow cart data to refresh
  await new Promise(resolve => setTimeout(resolve, delay));
  
  const response = await fetch('/cart.js');
 
  return response.json();
}

// Function to remove product from cart with retries
async function removeProductFromCart(productId, retries = 2) {
  if (!productId) {
    console.error('Invalid product ID provided');
    return false;
  }

  for (let attempt = 1; attempt <= retries + 1; attempt++) {
    try {
      // Fetch current cart details
      const cart = await fetchCartWithDelay(1000);
      
      if (!cart || !cart.items) {
        console.error('Invalid cart data received');
        return false;
      }

      // Find the item to remove
      const itemToRemove = cart.items.find(item => 
        item.id === parseInt(productId) || 
        item.product_id === parseInt(productId) ||
        item.variant_id === parseInt(productId)
      );
      
      if (!itemToRemove) {
        console.log(`Product ${productId} not found in cart`);
        return true; // Return true if item not found (it's already removed)
      }

      // Remove the item by changing its quantity to 0
      const changeResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: itemToRemove.key,
          quantity: 0
        })
      });

      if (!changeResponse.ok) {
        throw new Error(`HTTP error! status: ${changeResponse.status}`);
      }

      const data = await changeResponse.json();
      console.log('Product removed from cart:', data);
      return true;

    } catch (error) {
      console.error(`Error removing product from cart (attempt ${attempt}):`, error);
      
      if (attempt <= retries) {
        console.log(`Retrying removal (attempt ${attempt + 1})...`);
        await new Promise(resolve => setTimeout(resolve, 1000));
      } else {
        console.error('Failed to remove product after all retries');
        return false;
      }
    }
  }

  return false;
}

  
  function displayMessage(message) {
  const messageContainer = document.createElement('div');
  messageContainer.innerText = message;
  messageContainer.style.position = 'fixed';
  messageContainer.style.bottom = '20px';
  messageContainer.style.left = '50%';
  messageContainer.style.transform = 'translateX(-50%)';
  messageContainer.style.padding = '10px 20px';
  messageContainer.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
  messageContainer.style.color = 'white';
  messageContainer.style.borderRadius = '5px';
  messageContainer.style.zIndex = '1000';
  messageContainer.style.opacity = '0';
  messageContainer.style.transition = 'opacity 0.5s ease-in-out';

  // Append to the body
  document.body.appendChild(messageContainer);

  // Show the message
  setTimeout(() => {
    messageContainer.style.opacity = '1';
  }, 10);

  // Automatically hide after 3 seconds
  setTimeout(() => {
    messageContainer.style.opacity = '0';
    // Remove the element after hiding
    setTimeout(() => {
      document.body.removeChild(messageContainer);
    }, 500); // Match this timeout with the transition duration
  }, 3000);
}

// Function to remove all sample products from cart with retry logic
async function removeSampleProductsFromCart() {
  try {
    // Get stored product IDs and gift box info
    const storedProductIds = JSON.parse(localStorage.getItem('sampleProductIds')) || [];
    const selectedGiftBox = JSON.parse(localStorage.getItem('selectedGiftBox'));
    const giftBoxId = selectedGiftBox?.variantId || null;

    // If no items to remove, return early
    if (storedProductIds.length === 0 && !giftBoxId) {
      console.log('No sample products or gift box to remove');
      return;
    }

    let allRemoved = true;
    let attemptCount = 0;
    const maxAttempts = 2;

    while (attemptCount < maxAttempts) {
      allRemoved = true;

      // Remove sample products
      for (const productId of storedProductIds) {
        if (!productId) continue; // Skip invalid IDs
        
        console.log(`Attempting to remove product: ${productId}`);
        const removalSuccess = await removeProductFromCart(productId);
        
        if (!removalSuccess) {
          allRemoved = false;
          console.error(`Failed to remove product ${productId}`);
        }
      }

      // Remove gift box if it exists
      if (giftBoxId) {
        console.log(`Attempting to remove Gift Box: ${giftBoxId}`);
        const giftBoxRemoved = await removeProductFromCart(giftBoxId);

        if (!giftBoxRemoved) {
          allRemoved = false;
          console.error('Failed to remove gift box');
        } else {
          console.log('Gift Box removed successfully');
          localStorage.removeItem('selectedGiftBox');
        }
      }

      if (allRemoved) {
        // Clear localStorage only if all items were successfully removed
        localStorage.removeItem('sampleProductIds');
        console.log('All items removed successfully');
        break;
      }

      // If not all items were removed, wait and retry
      attemptCount++;
      if (attemptCount < maxAttempts) {
        console.log(`Retrying removal of remaining items (attempt ${attemptCount + 1})...`);
        await new Promise(resolve => setTimeout(resolve, 1000));
      }
    }

    if (!allRemoved) {
      console.warn('Some items could not be removed after all attempts');
    }

    // Update cart totals regardless of removal success
    await updateCartTotals();

  } catch (error) {
    console.error('Error in removeSampleProductsFromCart:', error);
    // Still try to update cart totals even if there's an error
    await updateCartTotals();
  }
}

  async function checkAndUpdateCart() {
  if (localStorage.getItem('cartUpdated') === 'true') {
    // Update cart totals
   updateCart()
    
    // Remove 'cartUpdated' from localStorage to prevent future triggers
    localStorage.removeItem('cartUpdated');
  }
}


// Poll every second to check for cart updates
setInterval(() => {
  checkAndUpdateCart();
}, 1000); // Check every second (1000 ms)

  
// Handle browser back button
window.addEventListener('popstate', async function(event) {
 const storedProductIds = JSON.parse(localStorage.getItem('sampleProductIds')) || [];

  if (storedProductIds.length > 0) {
    // Show message
    displayMessage('Removing sample products, please wait...');

    await removeSampleProductsFromCart();
    
  }

  // Navigate to the previous step
  goToPreviousStep();

  // Reload the page and update the URL
  location.reload();
  history.pushState({ step: currentStep }, "", `?step=1`);
});

  backButton.addEventListener("click", async function (event) {
    event.preventDefault();
    const storedProductIds = JSON.parse(localStorage.getItem('sampleProductIds')) || [];

  if (storedProductIds.length > 0) {
    // Show message
    displayMessage('Removing sample products, please wait...');

    await removeSampleProductsFromCart();
  }

  goToPreviousStep();
  location.reload(); 
  history.pushState({ step: currentStep }, "", `?step=1`);
  });

  nextButtons.forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      goToNextStep();
    });
  });
   tierHead.addEventListener("click", function() {
    const tierNumber = parseInt(this.dataset.tier);
    updateSamples(tierNumber);
  });

   showStep(currentStep);
  
// Function to check URL and perform actions
function handleLocationChange() {
  console.log('Location changed');
  // Handle removing sample products and navigating to previous step
  removeSampleProductsFromCart().then(() => {
    goToPreviousStep();
     
  });
}

// Polling for location changes
setInterval(() => {
  if (window.location.hash) {
    handleLocationChange();
  }
}, 1000);

// Listening to hash changes
window.addEventListener('hashchange', handleLocationChange);

 
  await removeSampleProductsFromCart()
  await updateCartTotals(); // Initial price calculation



  
});
